import Coordinate from "./Coordinate";

export default class PolyPotentialCoordinate extends Coordinate {
    constructor(provider, parent, index) {
        let [c1, c2] = parent.getSegmentCoordinates(index);
        let absX = (c1.absX + c2.absX) / 2;
        let absY = (c1.absY + c2.absY) / 2;

        super(provider, absX, absY);
        this.parent = parent;
        this.segmentIndex = index;
        this.index = index + 1;
    }

    display(g) {
        let opacity = this.hovered() ? 255 : 75;
        g.stroke(0, opacity);
        g.strokeWeight(1);
        g.fill(200, opacity);
        g.ellipse(this.currentX, this.currentY, this.size);
    }

    updatePosition() {
        let [c1, c2] = this.parent.getSegmentCoordinates(this.segmentIndex);
        this.absX = (c1.absX + c2.absX) / 2;
        this.absY = (c1.absY + c2.absY) / 2;
    }
}
